import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { LeftOutlined } from "@ant-design/icons";
import IndependentChat from "../UCIndependentChat/Chat";
import type { ThemeColors } from "../UCIndependentChat/hooks/useTheme";
import { usePageTheme } from "./theme/usePageTheme";
import V2PageFrame from "./components/V2PageFrame";
import V2Header from "./components/V2Header";
import "./styles/v2ChatOverrides.css";

interface UCChatViewProps {
  csUuid: string;
  code: string;
  uid: string;
  status?: string;
  category?: string;
  themeColors: ThemeColors;
  isDark: boolean;
  quickQaIds?: string[];
  onBack: () => void;
  onChatRef?: (ref: { fetchChatContent: () => Promise<void> }) => void;
  onSessionClosed?: () => void;
  hideHeader?: boolean;
}

const UCChatView: React.FC<UCChatViewProps> = ({
  csUuid,
  code,
  uid,
  status,
  category,
  themeColors,
  isDark,
  quickQaIds,
  onBack,
  onChatRef,
  onSessionClosed,
  hideHeader = false,
}) => {
  const intl = useIntl();
  const { tokens } = usePageTheme();

  const headerTitle = useMemo(() => {
    if (category) {
      return `${intl.formatMessage({ id: "consultation.type" })}${category}`;
    }
    return intl.formatMessage({
      id: "v2.customer_support",
      defaultMessage: "Customer Support",
    });
  }, [category, intl]);

  return (
    <V2PageFrame
      showHomeIndicator
      header={
        hideHeader ? undefined : (
          <V2Header
            title={headerTitle}
            left={
              <button
                type="button"
                onClick={onBack}
                style={{
                  border: "none",
                  background: "transparent",
                  color: tokens.text,
                  cursor: "pointer",
                  padding: 8,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <LeftOutlined style={{ fontSize: 18 }} />
              </button>
            }
            /* 当前会话入口暂时隐藏
            right={
              <button
                type="button"
                onClick={onOpenDrawer}
                style={{
                  border: "none",
                  background: "transparent",
                  color: tokens.text,
                  cursor: "pointer",
                  padding: 8,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <UnorderedListOutlined style={{ fontSize: 18 }} />
              </button>
            }
            */
          />
        )
      }
    >
      <div
        className="uchat-v2-chat"
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          background: tokens.background,
          overflow: "hidden",
        }}
      >
        <IndependentChat
          key={csUuid}
          csUuid={csUuid}
          code={code}
          uid={uid}
          onRef={onChatRef}
          status={status}
          themeColors={themeColors}
          isDark={isDark}
          quickQaIds={quickQaIds}
          uiVariant="v2"
          onSessionClosed={onSessionClosed}
        />
      </div>
    </V2PageFrame>
  );
};

export default UCChatView;
